import React from 'react';
import { GridContainer } from '@platform/base';
const GridItem = GridContainer.Item;
import Filed from '../field';

const formLayoutMap = {
    left: 'form-label-left',
    right: 'form-label-right',
    top: 'form-label-top',
    bottom: 'form-label-bottom',
};
export function NormalFromItem(props) {
    let {
        width = 25,
        leftSpaceCol = 0,
        isnextrow,
        singleWidth = 25,
        className,
        fieldid,
        hotkeytag,
        _runContext,
        formLayout,
        limitItemHeight,
        ...item
    } = props;
    let leftWidth = 0;
    if (isnextrow) {
        // 折行
        leftWidth = Number(leftSpaceCol) * singleWidth;
    }
    let style = {};
    if (item.itemtype === 'textarea' && !item.realBrowse) {
        style = {
            minWidth: String(width) + '%',
            maxHeight: 'none',
        };
    } else {
        style = { width: String(width) + '%' };
    }
    let layoutClassName = formLayoutMap[item.labelposition] || formLayoutMap[item.formLayout] || formLayoutMap[formLayout] || '';
    let formAlignClassName = item.align === 'left' ? 'form-item-align-left' : '';
    return <React.Fragment>
        <div
            style={{ width: String(leftWidth) + '%' }}
            className="leftspace form-item"
        />
        <div
            style={style}
            className={`${className} ${layoutClassName} ${formAlignClassName}`}
            fieldid={fieldid}
            hotkeytag={hotkeytag}
        >
            <Filed {...item} _runContext={_runContext} limitItemHeight={limitItemHeight}></Filed>
        </div>
    </React.Fragment>;
}

export function GridFormItem(props) {
    let {
        columnSpan,
        offsetColumn,
        rowSpan,
        className,
        fieldid,
        hotkeytag,
        moduleId,
        _runContext,
        limitItemHeight,
        ...item
    } = props;
    let layoutClassName = formLayoutMap[item.labelposition] || formLayoutMap[item.formLayout];
    let formAlignClassName = item.align === 'left' ? 'form-item-align-left' : '';
    return <GridItem
        className={`${className} ${layoutClassName} ${formAlignClassName}`}
        fieldid={fieldid}
        hotkeytag={hotkeytag}
        columnSpan={columnSpan}
        rowSpan={rowSpan}
        moduleId={moduleId}
        offsetColumn={offsetColumn}
    >
        {item.attrcode ? <Filed {...item} _runContext={_runContext} limitItemHeight={limitItemHeight}></Filed> : <div></div>}
    </GridItem>;
}